/* The mockup's `.card.table-wrap` and `.table`, as the session list draws them. */
.wrap {
  overflow-x: auto;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

/* Rows of a previous filter while the current one loads: present, but not read as its result. */
.busy tbody {
  opacity: 0.5;
}

.table th {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  text-align: start;
  white-space: nowrap;
}

.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  vertical-align: middle;
}

.table tbody tr:last-child td {
  border-block-end: 0;
}

.strong {
  font-weight: var(--font-weight-medium);
}

.meta {
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}
